import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGrid: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconGrid"><Path d="M8.5 3.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M15.5 3.5V20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 8.5H20.5" stroke="currentColor" strokeLinecap="square"/><Path d="M3.5 15.5H20.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconGrid;
